// language=GraphQL
export const ALL_ROLES_QUERY = `query Query($withPermissions: Boolean = false) {
  roles: rbacRoles {
    id
    name
    description
    permissions @include(if: $withPermissions) {
      id
      path
      module
      name
    }
  }
}`

// language=GraphQL
export const SINGLE_ROLE_QUERY = `query Query($id: ID!, $withPermissions: Boolean = false) {
  role: rbacRole(id: $id) {
    id
    name
    description
    permissions @include(if: $withPermissions) {
      id
      path
      module
      name
    }
  }
}`

// language=GraphQL
export const CREATE_ROLE_MUTATION = `
  mutation Mutation($input: CreateRbacRoleInput, $withPermissions: Boolean = false) {
    role: createRbacRole(input: $input) {
      id
      name
      description
      permissions @include(if: $withPermissions) {
        id
        path
        module
        name
      }
    }
  }`

// language=GraphQL
export const UPDATE_ROLE_MUTATION = `
  mutation Mutation($input: UpdateRbacRoleInput, $withPermissions: Boolean = false) {
    role: updateRbacRole(input: $input) {
      id
      name
      description
      permissions @include(if: $withPermissions) {
        id
        path
        module
        name
      }
    }
  }`

// language=GraphQL
export const DELETE_ROLE_MUTATION = `
  mutation Mutation($input: DeleteRbacRoleInput) {
    deleteRbacRole(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_ROLE_MUTATION = `
  mutation Mutation($input: DeleteRbacRoleInput) {
    forceDeleteRbacRole(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_ROLE_PERMISSIONS_MUTATION = `
  mutation Mutation($input: addRbacRolePermissionsInput) {
    addRbacRolePermissions(input: $input) {
      id
      permissionIds
    }
  }`

// language=GraphQL
export const REMOVE_ROLE_PERMISSIONS_MUTATION = `
  mutation Mutation($input: removeRbacRolePermissionsInput) {
    removeRbacRolePermissions(input: $input) {
      id
      permissionIds
    }
  }`

// language=GraphQL
export const CREATE_ROLE_PERMISSIONS_MUTATION = `
  mutation Mutation($input: createRbacRolePermissionsInput) {
    createRbacRolePermissions(input: $input) {
      id
      permissionIds
    }
  }`

// language=GraphQL
export const DELETE_ROLE_PERMISSIONS_MUTATION = `
  mutation Mutation($input: deleteRbacRolePermissionsInput) {
    deleteRbacRolePermissions(input: $input) {
      id
      permissionIds
    }
  }`

// language=GraphQL
export const ROLES_DEPENDENTS_QUERY = `query Query($id: ID!, $withUsers: Boolean = false, $withApiKeys: Boolean = false) {
  groupedDependents: rbacRoleDependents(id: $id) {
    users @include(if: $withUsers) {
      id
      email
      firstName
      lastName
    }
    apiKeys @include(if: $withApiKeys) {
      id
      name
      key
    }
  }
}`
